import { useSnackbar } from "notistack";
import { useEffect } from "react";

export function useErrorNotifications(errors) {
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				enqueueSnackbar(err.message, {
					variant: "error",
					preventDuplicate: true,
				});
			});
		}
	}, [errors, enqueueSnackbar]);
}
